import React from "react";
import "./ConfirmDelete.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const NoAccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="custom-modal"
      centered
    >
      <Modal.Header closeButton>
      </Modal.Header>
      <Modal.Body style={{ display: 'flex', justifyContent: 'center', padding: '30px' }}>
        Head over to the “My Courses” section to check out our Featured Courses
      </Modal.Body>
      {/* 
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onClose}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #949a9e",
            color: "#949a9e",
          }}
        >
          No
        </Button>
        <Button
          variant="primary"
          onClick={handleDelete}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #d1b794",
            color: "#d1b794",
          }}
        >
          Yes
        </Button>
      </Modal.Footer>
      */}
    </Modal>
  );
};

export default NoAccessModal;
